import { Tooltip, TooltipProps } from 'primereact/tooltip';
import useScrollListener from '../../hooks/useScrollListener';
import { useRef } from 'react';

type MLXToolTipProps = TooltipProps & {
  scrollElementId?: string
}

function MlxTooltip({
  scrollElementId,
  ...props
}: Readonly<MLXToolTipProps>) {
  const tooltipRef = useRef<Tooltip>(null);

  useScrollListener(scrollElementId ?? '', (scrollPosition) => {
    if (scrollElementId && (scrollPosition.x > 0 || scrollPosition.y > 0)) {
      tooltipRef?.current?.hide();
    }
  })

  return (
    <>
      <Tooltip ref={tooltipRef} target={props.target} autoZIndex={false} />
      {props.children}
    </>
  )
}

export default MlxTooltip